import React from "react";

export default function FactRow({ label, value, className = "" }) {
  return (
    <div
      className={`flex items-baseline justify-between gap-4 text-[15px] leading-[1.5] ${className}`}
    >
      <span className="text-text-light">{label}</span>
      <span className="font-bold text-text-dark text-right">{value}</span>
    </div>
  );
}
